import React from 'react'
import { Switch } from 'react-router-dom'

import Route from './Route'
import { FeatureFlagRoute, FeatureFlagCombinedRoute } from './FeatureFlagRoute'

import Login from '../pages/Login'
import Test from '../pages/Test'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import Profile from '../pages/Profile'
import Home from '../pages/Home'
import Course from '../pages/Course'
import DoubtsList from '../pages/DoubtsList'
import Doubt from '../pages/Doubt'
import Subscription from '../pages/Subscription'
import MyContents from '../pages/MyContents'
import SubscriptionList from '../pages/SubscriptionList'
import ExpirationInfo from '../pages/ExpirationInfo'
import Dashboard from '../pages/Dashboard'
import Questions from '../pages/Questions'
import MyMessages from '../pages/MyMessages'
import Message from '../pages/Message'
import SearchQuestions from '../pages/SearchQuestions'
import MyQuestionBooks from '../pages/MyQuestionBooks'
import QuestionBook from '../pages/QuestionBook'
import Lesson from '../pages/Lesson'
import Premium from '../pages/Premium'
import Planning from '../pages/Planning'

// EX para uso de rota com feature flag:
//{
/* <ExperimentRoute
      exact
      isPrivate
      path="/course/:courseId/module/:moduleId/lesson/:lessonId/chapter/:chapterId"
      featureFlag="new_chapter_page"
      defaultComponent={Lesson}
      testingComponent={LessonBeta}
    /> */
//}

const routes: React.FC = () => (
  <Switch>
    <Route exact path="/" component={Login} />
    <Route exact path="/test" component={Test} />
    <Route exact path="/forgot-password" component={ForgotPassword} />
    <Route exact path="/reset-pass" component={ResetPassword} />
    <Route exact isPrivate path="/config/:typeId/:orderId?" component={Profile} />
    <Route exact isPrivate path="/home" component={Home} />
    <Route exact isPrivate path="/course/:courseId" component={Course} />
    <Route
      exact
      isPrivate
      path="/course/:courseId/module/:moduleId/lesson/:lessonId/chapter/:chapterId"
      component={Lesson}
    />
    <Route exact isPrivate path="/duvidas" component={DoubtsList} />
    <Route exact isPrivate path="/duvida-respondida/:doubt/:number" component={Doubt} />

    <Route exact isPrivate path="/recados" component={MyMessages} />
    <Route exact isPrivate path="/recado/:messageId" component={Message} />

    <Route exact isPrivate path="/subscription/:subscriptionId" component={Subscription} />
    <Route exact isPrivate path="/subscription" component={SubscriptionList} />
    <Route exact isPrivate path="/my-contents" component={MyContents} />
    <Route exact isPrivate path="/prazos" component={ExpirationInfo} />
    <Route exact isPrivate path="/desempenho" component={Dashboard} />
    <FeatureFlagRoute
      featureFlag="menu_planning"
      exact
      isPrivate
      path="/planejamento"
      component={Planning}
    />
    <FeatureFlagRoute
      featureFlag="menu_planning"
      exact
      isPrivate
      path="/planejamento/novo"
      component={Planning}
    />
    <FeatureFlagRoute
      featureFlag="menu_planning"
      exact
      isPrivate
      path="/planejamento/:id"
      component={Planning}
    />
    <FeatureFlagRoute
      featureFlag="menu_questions"
      exact
      isPrivate
      path="/questoes"
      component={Questions}
    />
    <FeatureFlagRoute
      featureFlag="menu_questions"
      exact
      isPrivate
      path="/questoes/buscar"
      component={SearchQuestions}
    />
    <FeatureFlagRoute
      featureFlag="menu_questions"
      exact
      isPrivate
      path="/questoes/caderno/:id"
      component={QuestionBook}
    />
    <FeatureFlagRoute
      featureFlag="menu_questions"
      exact
      isPrivate
      path="/questoes/cadernos"
      component={MyQuestionBooks}
    />
    <FeatureFlagRoute
      featureFlag="menu_vip_classroom"
      exact
      isPrivate
      path="/course/652d448fc0734d00343ba192"
      component={Premium}
    />
    <FeatureFlagCombinedRoute
      featureFlag="menu_upsell_premium"
      featureFlagCombined="menu_vip_classroom"
      exact
      isPrivate
      path="/premium"
      component={Premium}
    />
  </Switch>
)

export default routes
